import { Component, OnInit } from '@angular/core';
import { PackageList, urlPath } from '../../shareModel';
import { Location } from '@angular/common';
import { isODM } from '../../../environments/environment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { trigger, style, transition, animate } from '@angular/animations';
import * as fromStore from '../../store';
import { Store, select } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-help-menu',
  templateUrl: './help-menu.component.html',
  styleUrls: ['./help-menu.component.css']
})
export class HelpMenuComponent implements OnInit {
  pathStringName: string;
  shareModel = {
    PackageList: PackageList,
    urlPath: urlPath
  };
  isSuperAdmin = false;
  powerMaster = isODM;
  isMsp = false;
  isMspLoaded = false;
  private componentDestroyed = new Subject();
  constructor(private ngxService: NgxUiLoaderService, private store: Store<fromStore.State>) {
    // Get User
    this.store
      .select(fromStore.getCurrentUser)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        this.isSuperAdmin = res.authority && res.authority === 2 ? true : false;
      });

    this.store.select(fromStore.getIsMsp).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res !== undefined && res !== null) {
        this.isMsp = res;
        this.isMspLoaded = true;
      }
    });
  }

  ngOnInit() {
    this.pathStringName = location.pathname.substr(6);
  }

}
